export const SpecificColors = {
    Purple: '#9d03fc',
    Gold: '#ffbf00',
    Silver: '#C0C0C0',
    Purple2: '#9848ff',
}
